import has from 'lodash/has';
import get from 'lodash/get';

export default class SetupPlugin {
	static install(Vue, options) {
		Vue.mixin({
			mounted() {
				if (this.$options.setup && typeof this.$options.setup === 'object') {
					for (let method of this.$options.setup) {
						has(this, method)
                        && typeof this[method] === 'function'
                        && get(this, method, () => {
                        	console.warn('Startup plugin: Method ' + method + ' not found');
                        })();
					}
				}
			},
			watch: {}
		});
	}
}